import { render, staticRenderFns } from "./NameReservationTask.vue?vue&type=template&id=00dd87ba&scoped=true&"
import script from "./NameReservationTask.vue?vue&type=script&lang=js&"
export * from "./NameReservationTask.vue?vue&type=script&lang=js&"
import style0 from "./NameReservationTask.vue?vue&type=style&index=0&id=00dd87ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00dd87ba",
  null
  
)

export default component.exports